export enum UnappliedFundsTab {
  UNPAID_INVOICES = 'UNPAID_INVOICES',
  FUNDS_HISTORY = 'FUNDS_HISTORY',
}

export interface FundsHistoryTransaction {
  id: string;
  amount: number;
  date: string;
  description: string;
}

export interface UnpaidInvoice {
  id: string;
  type: string;
  date: string;
  amount: number;
}

export type OrganizationAncestorLevel = 'partnerId' | 'distributorId' | 'employerId';

export interface OrganizationAncestor {
  id: string;
  level: OrganizationAncestorLevel;
  name?: string;
}

export interface OrganizationPathItem {
  id: string;
  name: string;
}
